import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />} />
      </Routes>
    </HashRouter>
    <Toaster 
      position="top-right" 
      toastOptions={{
        style: {
          background: '#000',
          color: '#fff',
          border: 'none',
          borderRadius: '0',
        },
      }}
    />
  </React.StrictMode>
);
